<template>
    <div class="w-full lg:w-2/3 lg:justify-end justify-space-around">
        <div :class="containerClasses">
            <ModuleLink v-for="module in orderedModules" :module="module" :key="module.id" />
        </div>
    </div>
</template>
<script>
import ModuleLink from './ModuleLink.vue';

export default {
    components: {
        ModuleLink
    },
    props: ['modules'],
    computed: {
        containerClasses() {
            const baseClasses = 'flex gap-6 flex-wrap';
            const isGestioneOrdiniPage = this.$page.url.includes('/modules/gestione-ordini');
            const hasSplitView = this.$page.props.hasSplitView;
            
            return isGestioneOrdiniPage && hasSplitView ? baseClasses : `${baseClasses} lg:flex-row-reverse`;
        },
        orderedModules(){
            return this.modules.sort((a, b) => {
                const aIsFalse = a.active === false;
                const bIsFalse = b.active === false;

                if (aIsFalse === bIsFalse) return 0;
                return aIsFalse ? 1 : -1;
            });
        }
    }
};
</script>